/**
 * @generated SignedSource<<365c68ae331729c829c5de1b037a1f34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConnectAdminInboxDeleteInboxMutation$variables = {
  id: string;
};
export type ConnectAdminInboxDeleteInboxMutation$data = {
  readonly store: {
    readonly connectInbox: {
      readonly delete: {
        readonly connectInbox: {
          readonly id: string;
        };
      };
    };
  };
};
export type ConnectAdminInboxDeleteInboxMutation = {
  response: ConnectAdminInboxDeleteInboxMutation$data;
  variables: ConnectAdminInboxDeleteInboxMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectAdminInboxDeleteInboxMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ConnectInboxMutations",
            "kind": "LinkedField",
            "name": "connectInbox",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConnectInboxDeletePayload",
                "kind": "LinkedField",
                "name": "delete",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConnectInbox",
                    "kind": "LinkedField",
                    "name": "connectInbox",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConnectAdminInboxDeleteInboxMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ConnectInboxMutations",
            "kind": "LinkedField",
            "name": "connectInbox",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConnectInboxDeletePayload",
                "kind": "LinkedField",
                "name": "delete",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConnectInbox",
                    "kind": "LinkedField",
                    "name": "connectInbox",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "filters": null,
                        "handle": "deleteRecord",
                        "key": "",
                        "kind": "ScalarHandle",
                        "name": "id"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "14adb246862ccda7440c66b891b33a56",
    "id": null,
    "metadata": {},
    "name": "ConnectAdminInboxDeleteInboxMutation",
    "operationKind": "mutation",
    "text": "mutation ConnectAdminInboxDeleteInboxMutation(\n  $id: ID!\n) {\n  store {\n    connectInbox(id: $id) {\n      delete {\n        connectInbox {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6265547295d2e2d7f2446280527b9eb6";

export default node;
